/**
 * How a practice reads on every screen (boards R1, R2, R3, R5): the six Types
 * in the Done screen's order, the date, the minutes, and the streak.
 */
export const practiceWords = {
  types: [
    ['tee', 'Tee'],
    ['soft_toss', 'Soft toss'],
    ['front_toss', 'Front toss'],
    ['machine', 'Machine'],
    ['live', 'Live'],
    ['side_toss', 'Side toss'],
  ] as const,

  typeList(types: string[]): string {
    return practiceWords.types.filter(([code]) => types.includes(code)).map(([, label]) => label).join(', ');
  },

  /** "Tue 27 Oct". A practice date is a calendar date, so it is read as one. */
  day(date: string): string {
    const [year = 0, month = 1, day = 1] = date.split('-').map(Number);
    const when = new Date(year, month - 1, day);
    return `${when.toLocaleDateString('en-US', { weekday: 'short' })} ${day} ${when.toLocaleDateString('en-US', { month: 'short' })}`;
  },

  /** "18 min"; past an hour, "4 h 05 m". */
  time(seconds: number): string {
    const minutes = Math.round(seconds / 60);
    if (minutes < 60) return `${minutes} min`;
    return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, '0')} m`;
  },

  days(count: number): string {
    return `${count} ${count === 1 ? 'day' : 'days'}`;
  },

  swings(count: number): string {
    return `${count} ${count === 1 ? 'swing' : 'swings'}`;
  },
};
